<!-- VariantSwatches.vue -->
<template>
  <div class="swatchContainerBlock">
    <div class="swatchContainer">
      <div v-for="variantProduct in filteredProducts" :key="variantProduct.id" class="productSwatchDisplay">
        <div class="swatchWrapper">
          <div class="productSwatch"
            :class="{ 'out-of-stock': getColorCodes(variantProduct).some(color => color.inventoryQuantity === 0), 'selected-swatch': selectedColor === variantProduct.productColor }"
            @click="getColorCodes(variantProduct).some(color => color.inventoryQuantity !== 0) && loadProductData(variantProduct, getColorCodes(variantProduct)[0])">
            <div v-for="color in getColorCodes(variantProduct).slice(0, 3)" :key="color.id" class="stackedColor"
              :style="getFlexColorStyle(getColorCodes(variantProduct).length, color.colorCode)"
              @mouseover="handleMouseOver(color.colorName)" @mouseleave="handleMouseLeave()">
            </div>
          </div>
          <div class="tooltip" v-if="hoveredColor === variantProduct.productColor">
            {{ hoveredColor }}
          </div>
        </div>
      </div>
    </div>
    <div class="bulkLoading" v-if="isLoadingMoreSwatches">Loading...</div>
    <div v-if="moreSwatchesAvailable && !isLoadingMoreSwatches" class="loadMoreSwatches">
      <button @click="handleLoadMoreSwatches">Load More Swatches</button>
    </div>
  </div>
</template>



<script>
  export default {
    props: {
      variantProducts: {
        type: Array,
        default: () => [],
      },
      moreSwatchesAvailable: {
        type: Boolean,
        required: true,
      },
      isLoadingMoreSwatches: {
        type: Boolean,
        required: true,
      },
      initialColor: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        hoveredColor: '',
        selectedColor: this.initialColor,
      };
    },
    watch: {
      initialColor(newColor) {
        this.selectedColor = newColor;
      }
    },
    computed: {
      filteredProducts() {
        return this.variantProducts.filter(variantProduct => {
          const colors = (variantProduct.swatchColorCodes || '').split(',').slice(0, 3);
          const isValid = colors.every(colorCode => colorCode && colorCode.trim());
          return isValid;
        });
      }
    },
    methods: {
      getColorCodes(variantProduct) {
        const colors = (variantProduct.swatchColorCodes || '').split(',').slice(0, 3);

        const colorCodes = colors
          .filter(colorCode => colorCode && colorCode.trim())
          .map(colorCode => ({
            id: `${variantProduct.id}-${colorCode.trim()}`,
            colorCode: colorCode.trim(),
            colorName: variantProduct.productColor || 'Unknown Color',
            inventoryQuantity: (variantProduct.variants || []).reduce((sum, variant) => sum + variant.inventoryQuantity, 0),
          }));
        return colorCodes;
      },
      getFlexColorStyle(totalColors, colorCode) {
        if (!colorCode) {
          return {
            display: 'none', // Hide swatch if no color code is provided
          };
        }

        const size = 100 / totalColors + '%';
        return {
          backgroundColor: `#${colorCode}`,
          width: size,
          height: '100%',
        };
      },
      loadProductData(product, color) {
        this.selectedColor = color.colorName;
        this.$emit('loadProductData', product, color);
      },
      handleMouseOver(colorName) {
        this.hoveredColor = colorName;
        console.log(`Hovered over: ${colorName}`); // Log to confirm tooltip trigger
      },
      handleMouseLeave() {
        console.log(`Mouse left: ${this.hoveredColor}`); // Log to confirm tooltip exit
        this.hoveredColor = '';
      },
      handleLoadMoreSwatches() {
        this.$emit('loadMoreSwatches');
      },
    },
  };
</script>

<style scoped>
  .swatchContainerBlock {
    margin-bottom: 24px;
    padding-bottom: 15px;
    border-bottom: 1px solid #DCDFE1;
  }

  .swatchContainer {
    display: flex;
    flex-wrap: wrap;
  }

  .swatchWrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
  }

  .productSwatch {
    display: flex;
    width: 25px;
    height: 25px;
    border: 1px solid #515E6B;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;
    margin: 3px;
    transition: opacity 0.3s ease;
  }

  .stackedColor {
    flex-grow: 1;
    height: 100%;
    display: block;
  }

  .productSwatch.selected-swatch {
    border: 2px solid #000;
    box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.50);
  }

  .swatchWrapper:not(.out-of-stock) {
    opacity: 1;
  }

  .productSwatch.out-of-stock {
    position: relative;
    cursor: not-allowed;
    opacity: 0.5;
  }

  .productSwatch.out-of-stock::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80%;
    /* Adjust width to fit the cross line better */
    height: 2px;
    background-color: red;
    transform: translate(-50%, -50%) rotate(45deg);
  }

  .tooltip {
    position: absolute;
    bottom: 110%;
    left: 50%;
    transform: translateX(-50%);
    padding: 5px;
    color: #fff;
    background: #333;
    border-radius: 6px;
    white-space: nowrap;
    z-index: 999;
    margin-bottom: 5px;
  }

  .loadMoreSwatches button {
    background: none;
    border: none;
    font-size: 16px;
    text-decoration: underline;
    padding: 0px;
    text-transform: capitalize;
    margin-bottom: 15px;
  }
</style>
